<template>
  <FilterArea
    v-model="selectedUserId"
    :entities="users"
    filter-area-class="filter-area-height-admin-users"
    :filter-fields="filterFields"
    :item-type="FilterAreaType.user"
    :aria-label="$localize('Users')"
    @change="selectUser"
  >
    <template #option-content="{ slotProps }">
      <div
        :id="slotProps.option.personaId"
        :user-id="slotProps.option.personaId"
        :data-test="slotProps.option.givenName + ' ' + slotProps.option.familyName"
        class="filter-area-list-item ellipsis"
        :class="{ 'active': slotProps.option.personaId === selectedUserId }"
      >
        <b :title="slotProps.option.givenName + ' ' + slotProps.option.familyName">
          {{ slotProps.option.givenName + ' ' + slotProps.option.familyName }}
        </b>
        <br>
        <div class="filter-item-with-icons">
          <small
            class="heading filter-area-item-heading ellipsis"
            :title="slotProps.option.emailAddress"
          >
            {{ slotProps.option.emailAddress }}
          </small>
          <div class="item-icons">
            <div v-if="slotProps.option.isBusinessPrimaryContact">
              <i
                v-tooltip.top="{
                  value: $localize(AccountSpecificLabelsProvider.getAccountLabelKey('UserIsPrimaryBusinessExplanatoryText')),
                  showDelay: 600
                }"
                class="fa-regular fa-envelope"
                aria-hidden="true"
              />
              <span
                class="visually-hidden"
              >
                {{ $localize(AccountSpecificLabelsProvider.getAccountLabelKey('UserIsPrimaryBusinessExplanatoryText')) }}
              </span>
            </div>
            <div v-if="slotProps.option.isBusinessAdminUser">
              <i
                v-tooltip.top="{
                  value: $localize('UserIsAdminExplanatoryText'),
                  showDelay: 600
                }"
                class="fa-solid fa-user-cog"
                aria-hidden="true"
              />
              <span class="visually-hidden">{{ $localize('UserIsAdminExplanatoryText') }}</span>
            </div>
            <div v-if="slotProps.option.isPreregistered">
              <i
                v-tooltip.top="{
                  value: $localize('UserIsPreregisteredExplanatoryText'),
                  showDelay: 600
                }"
                class="fa-solid fa-user-slash"
                aria-hidden="true"
              />
              <span class="visually-hidden">{{ $localize('UserIsPreregisteredExplanatoryText') }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </FilterArea>
</template>

<script setup lang="ts">
  import FilterArea from '@/VueComponents/SharedComponents/FilterArea/FilterArea.vue';
  import { FilterAreaType } from '@/VueComponents/SharedComponents/FilterArea/Enums/filterAreaType';
  import UserSummaryModel from '@/Models/userSummaryModel';
  import AccountSpecificLabelsProvider from '@/Utils/accountSpecificLabelsProvider';

  defineProps<{
    users: UserSummaryModel[]
  }>();

  const selectedUserId = defineModel<string | null>();

  const selectUser = (user: UserSummaryModel | null) => {
    selectedUserId.value = user?.personaId;
  };

  const filterFields = ['givenName', 'familyName', 'emailAddress'];
</script>

<style scoped lang="scss">
</style>